<div
  (mouseenter)="PauseInterval()"
  (mouseleave)="ResumeInterval()"
  [class.zeroTransitionDuration]="!runAnimation"
  [style.margin-left]="marginLeft + '%'"
  [style.transition-duration]="transmissionDuration + 'ms'"
  [style.width]="containerWidth + '%'"
  class="elements-container"
>
  <div
    *ngFor="let element of elements; index as i"
    [style.width]="elementWidth + '%'"
    class="carousel-element"
  >
    <ng-container
      *ngTemplateOutlet="template; context: { element: element, index: i }"
    ></ng-container>
  </div>
</div>
